import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="separate-invoices"
export default class extends Controller {
  static targets = ["checkbox", "customerSelect", "travelerSection"]

  connect() {
    this.refresh()
  }

  refresh() {
    if (!this.hasCustomerSelectTarget) return
    const isChecked = this.hasCheckboxTarget && this.checkboxTarget.checked
    const selectedId = this.customerSelectTarget.value

    this.travelerSectionTargets.forEach(section => {
      const shouldShow = isChecked && section.dataset.travelerId !== selectedId
      section.classList.toggle("d-none", !shouldShow)
      section.querySelectorAll("input:not([type='hidden']), select").forEach(field => {
        field.required = shouldShow
        if (!shouldShow) field.value = ""
      })
    })
  }
}
